// MapLibre GL v6 resolves its rendering worker's URL from `import.meta.url` of
// its own bundled module — a value that isn't a usable http(s) URL once
// webpack code-splits it into a dynamically-loaded chunk, so auto-detection
// silently yields an empty worker URL and `new Worker('')` fails. Point it at
// the worker file explicitly instead; copied to this fixed path by webpack.config.js.
// (@defra/interactive-map's own `workerUrl` provider option predates this
// MapLibre v6 API change and calls the removed `mapFramework.workerUrl = ...`
// setter, so it can't be used here — see providers/maplibre/src/index.js.)
const WORKER_URL = '/public/javascripts/maplibre-gl-worker.mjs'

let configured

/**
 * Set MapLibre's worker URL before any map is created. Safe to call from
 * multiple entry points — the import (and its setup) only happens once.
 * @returns {Promise<void>}
 */
export function configureMapLibreWorker() {
  configured ??= import('maplibre-gl').then(({ setWorkerUrl }) => {
    setWorkerUrl(WORKER_URL)
    return undefined
  })

  return configured
}
